/**
 * Cases Slider Component
 */
var generaxion_cases_slider_find_and_init = function() {

 jQuery('.cases-slider .cases').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    speed: 500,
    cssEase: 'linear',
    responsive: [
    {
      breakpoint: 559,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: true,
        centerMode: true,
        centerPadding: '20px'
      }
    }
    ]
 });

}
generaxion_cases_slider_find_and_init();
